module.exports = "<!-- <div [@routerAnimation]=\"getRouteAnimation(route)\"> -->\r\n  <router-outlet ></router-outlet>\r\n<!-- </div> -->"


//////////////////
// WEBPACK FOOTER
// E:/sree/New folder (3)/cdk-material-v2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main